import { useEffect, useState } from 'react';

import useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges from 'components/hooks/useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useSelector } from 'react-redux';
import { okrCreationPanelStateSelector } from 'selectors/okrCreationPanelSelector';

import { MAX_OKR_NAME_LENGTH, MIN_OKR_NAME_LENGTH, OKR_TYPES } from 'constants/ProjectConstants';
import { StringModifier, modifyString } from 'constants/copyHelpers';

export const useOKRCreationValidation = () => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  const [error, setError] = useState('');
  const okrDetails = useSelector(okrCreationPanelStateSelector);
  const { text, parentPost, type, objectiveLevel } = okrDetails;
  const { canCreateKeyResultAtRootLevel } = useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges();

  const isKeyResult = type !== OKR_TYPES.OBJECTIVE;
  const isObjective = !isKeyResult;

  useEffect(() => {
    if (text.length < MIN_OKR_NAME_LENGTH) {
      setError('Title cannot be empty.');
      return;
    }

    if (text.length > MAX_OKR_NAME_LENGTH) {
      setError(`Title cannot be more than ${MAX_OKR_NAME_LENGTH} characters`);
      return;
    }

    if (isKeyResult && !canCreateKeyResultAtRootLevel && !parentPost?.uuid) {
      setError(
        `Parent ${modifyString(moduleName, StringModifier.SENTENCE_CASE)} is mandatory for creating new ${modifyString(
          keyResultsName,
          StringModifier.SENTENCE_CASE
        )}`
      );
      return;
    }

    if (isObjective && objectiveLevel !== 'COMPANY' && !parentPost?.uuid) {
      setError(
        `Parent ${modifyString(
          moduleName,
          StringModifier.SENTENCE_CASE
        )} mandatory for non Company Level ${modifyString(objectivesName, StringModifier.SENTENCE_CASE)}`
      );
      return;
    }

    setError('');
  }, [
    text,
    isKeyResult,
    canCreateKeyResultAtRootLevel,
    parentPost?.uuid,
    isObjective,
    objectiveLevel,
    moduleName,
    keyResultsName,
    objectivesName,
  ]);

  return error;
};
